let dotenvVars = {};
try {
  if (typeof window === 'undefined') {
    dotenvVars =
      require('dotenv-flow').config({
        node_env: process.env.APP_ENV,
        default_node_env: 'development',
      }).parsed || {};
  }
} catch (e) {
  dotenvVars = {};
}
// // eslint-disable-next-line no-console
// console.info('APP_ENV', process.env.APP_ENV);
// // eslint-disable-next-line no-console
// console.info('NODE_ENV', process.env.NODE_ENV);

const packageJson = require('../package.json');

// Client-safe only. Do not bake Kafka/Aerospike/APP_ENV — webpack.client DefinePlugin
// inlines these into the public bundle (source maps). Server code uses getAppEnv().raw.
const BAKED_IN_ENV_VARS = [
  'NODE_ENV',
  'PUBLIC_URL',
  'VERSION',
  'BUS_FQDN',
  'PLACES_AUTOCOMPLETE_URL',
  'OFFERS_URL',
  'OLD_BUS_SEO_BASE_URL',
];

function getAppEnv() {
  const raw = Object.keys(dotenvVars || {}).reduce(
    (env, key) => {
      env[key] = process.env[key];
      return env;
    },
    {
      NODE_ENV: process.env.NODE_ENV,
      PUBLIC_URL: process.env.PUBLIC_URL,
      VERSION: packageJson.version,
    },
  );

  // AWS/ECS defaults in .env; GCP Helm env wins; code fills gaps by cloud.
  if (typeof window === 'undefined') {
    try {
      const {
        applyCloudDefaultsToEnv,
      } = require('../server/cloud/infraConfig');
      applyCloudDefaultsToEnv(raw);
    } catch (e) {
      // ignore when cloud helpers are unavailable in some build contexts
    }
  }

  const forWebpackDefinePlugin = {
    'process.env': Object.keys(raw).reduce((env, key) => {
      if (BAKED_IN_ENV_VARS.includes(key)) {
        env[key] = JSON.stringify(raw[key]);
      }
      return env;
    }, {}),
  };

  const forIndexHtml = JSON.stringify({
    env: raw,
  });

  return { raw, forIndexHtml, forWebpackDefinePlugin };
}

module.exports = {
  getAppEnv,
};
